import styled from "@emotion/styled";
import React from "react";
import {
  renderMarkRule,
  type StructuredText as DatoStructuredText,
} from "react-datocms";

const StyledU = styled.u`
  text-underline-offset: 0.125rem;
`;

const underlineRenderRule = renderMarkRule("underline", ({ children, key }) => {
  return <StyledU key={key}>{children}</StyledU>;
});

const defaultStructuredTextMarkRules: React.ComponentProps<
  typeof DatoStructuredText
>["customMarkRules"] = [underlineRenderRule];

export default defaultStructuredTextMarkRules;
